import React, { useEffect, useMemo, useRef, useState } from "react";
import { Form } from "react-bootstrap";
// date format
import moment from "moment";
import TypesinscriptionsService from "../typesinscriptions/TypesinscriptionsService";
import GrillestarifairesService from "../grillestarifaires/GrillestarifairesService";
import StatutapprenantService from "../statutapprenants/StatutapprenantService";
import ClassesService from "../classe/ClassesService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import PaysService from "../pays/PaysService";
import InscriptionsService from "./InscriptionsService";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { InputText } from 'primereact/inputtext';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import { useSelector } from "react-redux";
import { Dropdown } from 'primereact/dropdown';
import { classNames } from "primereact/utils";
import SexesService from "../sexes/SexesService";
import $ from 'jquery'
import TranchesscolaritesService from "../tranchesscolarites/TranchesscolaritesService";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import Swal from "sweetalert2";
import ModesPaiementsService from "../modespaiements/ModesPaiementsService";
import { myroutes } from "../../routes/webroute";
import { useNavigate } from "react-router-dom";

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OverlayPanel } from 'primereact/overlaypanel';
import LiensParentauxService from "../liensparentaux/LiensParentauxService";
import AnneesacademiquesService from "../anneesacademiques/AnneesacademiquesService";


export default function InscriptionForm(props) {

    const [errors, setErrors] = useState({});
    // get token
    const token = useSelector(state => state.auth.token)


    // initialisation des variables
    const [inscriptionApprenantForm, setInscriptionApprenantForm] = useState({
        nomPersonne: '',
        prenomsPersonne: '',
        telephone: '',
        sexeId: '',
        ddn: '',
        lieuNaissance: '',
        classeId: '',
        classeoptionId: '',
        paysId: '',
        statutapprenantId: '',
        nompereInscription: '',
        nommereInscription: '',
        contactprincipalInscription: '',
        contactsecondaireInscription: '',
        emailInscription: '',
        autreinfoInscription: '',
        montant_scolarite: 0,
        typeinscriptionId: '',
        modepaiementId: '',
        anneeacademiqueId: '',
        inscripteurInscription: '',
        isScolarite: false,
        lienparentalId: '',
    });
    

    const [classes, setClasses] = useState([])
    const [selectedClasse, setSelectedClasse] = useState(null)
    const [classeoptions, setClasseOptions] = useState([])
    const [selectedClasseOption, setSelectedClasseOption] = useState(null)
    const [pays, setPays] = useState([])
    const [selectedPays, setSelectedPays] = useState(null)
    const [sexes, setSexes] = useState([])
    const [anneesacademiques, setAnneesacademique] = useState([])
    const [selectedSexe, setSelectedSexe] = useState(null)
    const [selectedAnneesacademique, setSelectedAnneesacademique] = useState(null)
    const [parents, setParents] = useState([])
    const [statutapprenants, setStatutapprenants] = useState([])
    const [selectedParent, setSelectedParent] = useState(null)
    const [montantScolarite, setMontantScolarite] = useState(0)
    const [fraisInscription, setFraisInscription] = useState(0)
    const [idTypeInscription, setIdTypeInscription] = useState(null)
    const [selectedCivilite, setSelectedCivilite] = useState(null)
    const [listeGrilles, setListeGrilles] = useState([])



    const [selectedStatutApprenant, setSelectedStatutApprenant] = useState(null)

    const [selectedCategories, setSelectedCategories] = useState([]);

    //Variables des tranche scolarites
    const [trancheScolarites, setTrancheScolarites] = useState([])
    const [selectedTrancheScolarite, setSelectedTrancheScolarite] = useState([])
    const [modepaiements, setModePaiements] = useState([]);
    const [selectedModepaiement, setSelectedModepaiement] = useState(null);

    //Gestion du montant restant après deduction de tous les frais
    const [reste, setReste] = useState(0)

    //Gestion des frais
    const [sommeFrais, setSommeFrais] = useState(0)
    //Somme du montant des tranche scolarité sélectionnées
    const [sommeTranche, setSommeTranche] = useState(0)

    const [montant_recu, setMontantRecu] = useState(0)
    //Versment partiel des rais de scolarité
    const [versementPartiel, setVersementPartiel] = useState(false)
    const [selectedTranchePartiel, setSelectedTranchePartiel] = useState(null)
    //Autre montant correspondant à un paiement partiel d'une tranche de la scolarité
    const [autreMontantTranche, setAutreMontantTranche] = useState(0)
    //lien parental
    const [liensParentaux, setLiensParentaux] = useState([]);
    const [selectedLienParental, setSelectedLienParental] = useState(null);
    //Afficher le reste des options de tranche scolarité disponible en paiement partiel
    const [listeTrancheScolaritePartiel, setListeTrancheScolaritePartiel] = useState([])
    //Garder en mémoire frais inscription grille tarifaire id
    const [fraisInscriptionGrilleTarifaireId, setFraisInscriptionGrilleTarifaireID] = useState('')

    const navigate = useNavigate()
    //Gestion des categories de frais divers
    const onCategoryChange = (e) => {

        // initialiser les choix disponibles
        let _selectedCategories = [...selectedCategories];

        if (e.checked) {
            _selectedCategories.push(e.value);
            //Ajouter les frais divers à la somme à payer
            const totalMontant = e.value.montant + sommeFrais
            setSommeFrais(totalMontant)

        } else {
            _selectedCategories = _selectedCategories.filter(category => category.id !== e.value.id);
            //Soustraire les montant de la somme totale
            const montantSupprimer = sommeFrais - e.value.montant
            //console.log(e.value.montant)
            setSommeFrais(montantSupprimer)
        }

        setSelectedCategories(_selectedCategories);
    };


    //Gestion des autres infos de l'apprenant
    const handleAutresInfos = (event) => {
        const { name, value } = event.target;
        let errorData = { ...errors };
        let _data = { ...inscriptionApprenantForm };
        _data[name] = value;
        setInscriptionApprenantForm(_data);
    };


    //Gestion des changements sur les input
    const onInputChange = (e, name) => {
        //const val = (e.target && e.target.value) || '';
        let _data = { ...inscriptionApprenantForm };
        _data[`${name}`] = e.target?.value || '';

        setInscriptionApprenantForm(_data);
    }


    // récupéré la liste des classes
    const fecthClasse = async () => {
        await ClassesService.index(token).then(({ data }) => {
            if (data.data.classes.length > 0) {
                const optionClasse = data.data.classes.map((option, index) => {
                    return ({ name: option.libelleClasse, code: option.id })
                })
                setClasses(optionClasse)
            }

        }).catch(({ response }) => {
            // console.log("erreur => " + response)
        })
    }

    //get liste annesacademiques
    const fetchAnneeacademique = async () => {
        try {
            const response = await InscriptionsService.getAnneeAcademique(token);
            const data = response.data;

            if (data) {
                setAnneesacademique([data]); // Enregistre la liste pour potentiellement l'utiliser ailleurs
                setInscriptionApprenantForm((prevForm) => ({
                    ...prevForm,
                    anneeacademiqueId: data.id, // Enregistre l'ID de l'année
                    descriptionAnneeacademique: `${data.anneedebutAnneeacademique} - ${data.anneefinAnneeacademique}`, // Enregistre la description
                }));
            }
        } catch (error) {
            setErrors("Erreur lors de la récupération de l'année académique.");
            console.error("Erreur:", error);
        }
    };

    // gestion changement classe
    const onChangeClasse = async (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['classeId'] = e.code;
        _data['classeoptionId'] = '';
        setInscriptionApprenantForm(_data);
        setSelectedClasse(e);
        // récupérer la liste des classes options selon le choix de la classe 
        await fetchClassesoptions(e.code)
        setSelectedClasseOption(null)

        //Recupérer les frais d'inscriptions
        await getFraisInscription(e.code)

        //Recupérer les frais divers
        getFraisDivers(e.code)
        //getMontant(0);  
        _data['montant_scolarite'] = 0;
        setInscriptionApprenantForm(_data)

    };

    // gestion changement classe option
    const onChangeClasseOption = (e) => {
        //console.log("actual class ==> "+inscriptionApprenantForm.classeId)
        let _data = { ...inscriptionApprenantForm };
        _data['classeoptionId'] = e.code;
        setInscriptionApprenantForm(_data);
        setSelectedClasseOption(e);
        //tranche scolarite initialise
        setSelectedTrancheScolarite()

        // récupéré le montant de la socolarité
        getMontantScolarite(e.code)
    };

    //get liste classesoptions
    const fetchClassesoptions = async (id) => {
        await ClassesoptionsService.getOptionByClasse(id, token).then((res) => {
            //console.log(res.data.data)
            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    return { code: options.id, name: options.libelleClasseOption }
                })
                setClasseOptions(options)
            } else {
                setClasseOptions([])
            }
        }).catch(error => {
            console.log(error)
        })
    }

    // gestion changement statut apprenant option
    const onChangeStatutApprenant = (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['statutapprenantId'] = e.code;
        setInscriptionApprenantForm(_data);
        setSelectedStatutApprenant(e);
    };


    //get montant scolarité
    const getMontantScolarite = async (id) => {
        await ClassesoptionsService.getMontant(id, token).then((res) => {
            let _data = { ...inscriptionApprenantForm };
            var _montant_scolarite = res.data.data;
            _data['montant_scolarite'] = _montant_scolarite;
            setInscriptionApprenantForm(_data);
            setMontantScolarite(_montant_scolarite);
            //Mettre à jour la valeur des tranche dans le select
            //console.log(_montant_scolarite)
            //tranche scolarite initialise
            setSelectedTrancheScolarite()
            //_data['autre_montant_tranche'] = 0;
            //setInscriptionApprenantForm(_data);
            fetchTrancheScolarite(_montant_scolarite)

            //return true;
        }).catch(error => {
            console.log(error)
        })
    }

    //get frais inscription
    /*const getFraisInscription = async (classeId) => {
        // get id type inscription 
        await GrillestarifairesService.getMontant(idTypeInscription, classeId, token).then((res) => {
            let frais_insc = res.data.data;
            setFraisInscription(frais_insc);
            return true;
        }).catch(error => {
            console.log(error)
        })
    }*/

    const getFraisInscription = (classeId) => {
        return new Promise((resolve, reject) => {
            GrillestarifairesService.getMontant(idTypeInscription, classeId, token)
                .then((res) => {
                    //Recupérer les frais d'inscription et l'id de la grille tarifaire
                    const montant = res.data.data.map(option => { return option[0] });
                    const grilletarifaireId = res.data.data.map(option => { return option[1] });
                    setFraisInscription(montant);
                    //console.log(parseInt(donnees))
                    //Get frais inscription grilletarifaireID
                    setFraisInscriptionGrilleTarifaireID(grilletarifaireId)
                    resolve(true);

                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    };



    //get frais divers
    const getFraisDivers = async (classeId) => {

        await GrillestarifairesService.getFraisDivers(classeId, token).then((res) => {
            let frais_divers = res.data.data;
            //console.log(frais_divers)
            const _listefrais = frais_divers.map((index, element) => {
                /**Vérifier si le libelle de la categorie contient le mot 'inscription' */
                /**Afficher uniquement les frais qui ne dépendent pas du type d'inscription */
                if (index.isInscription !== true) {
                    //index.isRequired ? setSommeFrais(sommeFrais => sommeFrais + index.montantGrilleTarifaire) : setSommeFrais(sommeFrais)
                    //else setSommeFrais(0);
                    return { "montant": index.montantGrilleTarifaire, "isRequired": index.isRequired, "libelle": index.libelleCategorie, "id": index.id }
                }

            })
            setListeGrilles(_listefrais)

            //Addionner les frais lorsque c'est a payer obligatoirement
            const totalMontantRequired = _listefrais.reduce((total, grille) => {
                if (grille.isRequired && grille.isInscription !== true) {
                    return total + grille.montant;
                }
                return total;
            }, 0);
            //console.log(totalMontantRequired);
            setSommeFrais(totalMontantRequired)

            //console.log(sommeFrais)
        }).catch(error => {
            console.log(error)
        })
    }


    //get type inscription
    const FetchTypeInscription = async () => {
        // get id type inscription 
        let libelle = "INSCRIPTION"
        await TypesinscriptionsService.getByLibelle(libelle, token).then((res) => {
            let _idTypeInscription = res.data.data.id;
            setIdTypeInscription(_idTypeInscription);
            let _data = { ...inscriptionApprenantForm };
            _data["typeinscriptionId"] = _idTypeInscription
            setInscriptionApprenantForm(_data)
            return true;
        }).catch(error => {
            console.log(error)
        })
    }

    //get liste pays
    const fetchPays = async () => {
        await PaysService.liste(token).then((res) => {
            //console.log(res.data.data)
            if (res.data.data.length > 0) {
                const options = res.data.data.map((options, index) => {
                    //console.log(options.nationalitePays)
                    return { code: options.id, name: options.nompaysPays + '/' + options.nationalitePays }
                })
                setPays(options)
            }
        }).catch(error => {
            console.log(error)
        })
    }

    // update pays selected
    // gestion changement pays
    const onChangePays = (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['paysId'] = e.code;
        setInscriptionApprenantForm(_data);
        setSelectedPays(e);
    };

    //get liste sexe
    const fetchSexes = async () => {
        await SexesService.index(token).then((res) => {
            if (res.data.data.sexes.length > 0) {
                const options = res.data.data.sexes.map((options, index) => {
                    return { code: options.id, name: options.libelleSexe }
                })
                setSexes(options)
            }

        }).catch(error => {
            console.log(error)
        })
    }

    //get liste sexe
    /*const fetchAnneesacademiques = async () => {
      await AnneesacademiquesService.index(token).then((res) => {
          if (res.data.data.anneesacademiques.length > 0) {
              const options = res.data.data.anneesacademiques.map((options, index) => {
                  return { code: options.id, name: options.anneedebutAnneeacademique + ' - ' + options.anneefinAnneeacademique }
              })
              setAnneesacademique(options)
          }

      }).catch(error => {
          console.log(error)
      })
  }*/

    //Gestion changement sexe
    const onChangeSexe = (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['sexeId'] = e.code;
        setInscriptionApprenantForm(_data);
        //Recupérer le sexe sélectionner pour l'afficher dans le select
        setSelectedSexe(e);
    };

    //Gestion changement sexe
    const onChangeAnneeacademique = (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['anneeacademiqueId'] = e.code;
        setInscriptionApprenantForm(_data);
        setSelectedAnneesacademique(e);
    };


    // récupéré la liste statut apprenant
    const FetchStatutApprenant = async () => {
        await StatutapprenantService.liste(token).then(({ data }) => {

            if (data.data.length > 0) {
                const options = data.data.map((option, index) => {
                    return ({ name: option.libelleStatutapprenant, code: option.id })
                })
                setStatutapprenants(options)
            }

        }).catch(({ response }) => {
            // console.log("erreur => " + response)
        })
    }

    //Gestion des changements du montant reçu ou payé par le parent
    const onChangeMontantPayer = (e) => {
        //const val = (e.target && e.target.value) || 0;
        /*let _data = { ...inscriptionApprenantForm };
        _data[`${name}`] = e.target?.value || 0;

        setInscriptionApprenantForm(_data);*/
        setMontantRecu(e.target.value)
        //console.log(montant_recu)
    }

    //Gestion des changements du montant partiel payer par le parent
    const onChangeMontantPartielPayer = (e) => {
        setAutreMontantTranche(e.target.value)
        // console.log(autreMontantTranche)
    }

    //get liste tranche scolarite
    const fetchTrancheScolarite = async (montant_scolarite) => {
        await TranchesscolaritesService.index(token).then(res => {
            if (res.data.data.tranchesscolarites.length > 0) {
                const optionTranche = res.data.data.tranchesscolarites.map((option, index) => {
                    const montantCalcul = !montant_scolarite ? option.pourcentageTrancheScolarite + '%' : (option.pourcentageTrancheScolarite / 100) * (montant_scolarite);
                    return ({ name: option.libelleTrancheScolarite + ' ==> ' + montantCalcul, code: option.id, pourcentage: option.pourcentageTrancheScolarite });

                    //return ({ name: option.libelleTrancheScolarite + ' ==> ' + (option.pourcentageTrancheScolarite / 100) * (inscriptionApprenantForm.montant_scolarite), code: option.id })
                }).reverse()

                // Ajoutez manuellement l'option "Autre"
                //optionTranche.push({ name: 'Autre', code: '0' });

                setTrancheScolarites(optionTranche)
                //Integrer également les tranche partielle
                setListeTrancheScolaritePartiel(optionTranche)

            } else {
                setTrancheScolarites([])
                Swal.fire({
                    icon: "warning",
                    text: "Pas de tranche pour cette classe !",
                    showConfirmButton: true,
                    timer: 3000,
                });
            }

            //setTrancheScolarites(res.data.data.tranchesscolarites)
        }).catch(err => {
            console.log(err)
        })
    }

    // gestion changement tranche scolarite
    const onChangeTrancheScolarite = async (selectedValue) => {
        setSelectedTrancheScolarite(selectedValue)
        //Afficher la zone autre montant si aucune tranche scolarite ne correspond
        /*let tranches = selectedValue.map(option => { return option.name })
        tranches.forEach((tranche) => {
            if (typeof tranche === 'string' && tranche.toLowerCase().includes("autre")) {
                $("#bloc_tranche_scolarite").removeClass("visually-hidden")
                $("#autre_montant_tranche").removeClass("visually-hidden")
                $("#autre_montant_tranche").attr("required", true)
            } else {

                $("#bloc_tranche_scolarite").addClass("visually-hidden")
                $("#autre_montant_tranche").addClass("visually-hidden")
                $("#autre_montant_tranche").removeAttr("required")
            }
        });*/

        //get value of montant

        //await TranchesscolaritesService.show()
        //const calculReste = inscriptionApprenantForm.montant_scolarite - fraisInscription
        //console.log(selectedValue.map(option => { return option.pourcentage }))
        //console.log(inscriptionApprenantForm.montant_scolarite)

        /**Calculer le montant payé pour la scolarité */
        /**Ajouter le montant des tranches cochés au total à payé */
        const calculSommeTranche = selectedValue.reduce((total, option) => {
            const montant = (option.pourcentage / 100) * (inscriptionApprenantForm.montant_scolarite);
            return total + montant;
        }, 0);


        setSommeTranche(calculSommeTranche)
        // Vérifier si au moins une option est sélectionnée
        const isAtLeastOneSelected = selectedValue.length > 0;
        // Mettre isScolarité sur true si au moins une option est sélectionnée, sinon false
        let _data = { ...inscriptionApprenantForm };
        _data['isScolarite'] = isAtLeastOneSelected;
        setInscriptionApprenantForm(_data);

        //Filtrer les tranches scolarité disponibles en paiement partiel
        //Retirer la tranche sélectionnée de la liste des tranches scolarité disponibles en paiement partiel
        const dataList = trancheScolarites.filter(tranche => !selectedValue.includes(tranche))
        //console.log(dataList)
        setListeTrancheScolaritePartiel(dataList)

        //setReste(calculReste)

    };

    //Fetch mode paiements
    const fetchModePaiements = async () => {
        await ModesPaiementsService.index(token).then(res => {
            if (res.data.data.modespaiements.length > 0) {
                const options = res.data.data.modespaiements.map((options, index) => {
                    return { code: options.id, name: options.libelleModepaiement }
                })
                setModePaiements(options)
            } else {
                setModePaiements([])
            }
            //setModePaiements(res.data.data.modespaiements)
        }).catch(err => {
            console.log(err)
        })
    };

    const onChangeModePaiement = async (e) => {
        let _data = { ...inscriptionApprenantForm };
        _data['modepaiementId'] = e.code;
        setInscriptionApprenantForm(_data);
        setSelectedModepaiement(e)
    }


    //Frais la somme des frais à payer par le parent d'élève
    const calculFrais = useMemo(() => {
        // Calcul de la somme des frais en fonction de fraisInscription
        return sommeFrais + (parseInt(fraisInscription) ? parseInt(fraisInscription) : 0) + sommeTranche + (parseInt(autreMontantTranche) ? parseInt(autreMontantTranche) : 0);
    }, [sommeFrais, fraisInscription, sommeTranche, autreMontantTranche]);

    //Calcule du montant restant après deduction de tout les frais à payer
    /**
     * Surveiller le montant recu pour actualiser le reste
     */
    const calculMontantRestant = useMemo(() => {
        return montant_recu;
    }, [montant_recu])


    //Versement partiel des frais de scolarité
    const onChangeVersementPartiel = async (e) => {

        //Afficher la section pour renseigner manuellement le montant
        if (e.checked) {
            $("#bloc_tranche_partiel").removeClass("visually-hidden")
            $("#autre_montant_tranche").removeClass("visually-hidden")
            $("#autre_montant_tranche").attr("required", true)
            $("#selectedTrancheScolarite").attr("required", true)

            //Filtrer les tranches scolarité disponibles en paiement partiel
            if (selectedTrancheScolarite != null) {
                const dataList = trancheScolarites.filter(tranche => !selectedTrancheScolarite.includes(tranche))
                //console.log(dataList)
                setListeTrancheScolaritePartiel(dataList)

            }

        } else {

            $("#bloc_tranche_partiel").addClass("visually-hidden")
            $("#autre_montant_tranche").addClass("visually-hidden")
            $("#autre_montant_tranche").removeAttr("required")
            $("#selectedTrancheScolarite").removeAttr("required")

            //Deselectionner la tranche selectionner
            setSelectedTranchePartiel()
            //Mettre montant partiel a payer sur 0
            setAutreMontantTranche(0);
            if (selectedTrancheScolarite != null) {
                //Filtrer les tranches scolarité disponibles en paiement partiel
                const dataList = trancheScolarites.filter(tranche => !selectedTrancheScolarite.includes(tranche))
                //console.log(dataList)
                setListeTrancheScolaritePartiel(dataList)

            }



        }
        setVersementPartiel(e.checked)

    }

    //get liens parentaux
    const fetchLiensParentaux = async () => {
        await LiensParentauxService.index(token).then((res) => {
            //console.log(res.data.data)
            if (res.data.data.liensparentaux.length > 0) {
                const options = res.data.data.liensparentaux.map((options, index) => {
                    return { code: options.id, name: options.libelleLienparental }
                })
                //options.push({ code: "autre", name: "Autre" })
                setLiensParentaux(options);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    //Gestion changement liens parentaux
    /*const onChangeLiensParentaux = (e) => {
        //console.log(e.name.toLowerCase())
        let _data = { ...inscriptionApprenantForm };
        _data['lienparentalId'] = e.code;
        setInscriptionApprenantForm(_data);
        //Recupérer le sexe sélectionner pour l'afficher dans le select
        setSelectedLienParental(e);
        //Afficher le champs inscripteur si le lien parental est autre
        if (e.name.toLowerCase().includes("autre")) {
            $("#bloc_inscripteurInscription").removeClass("visually-hidden")
            $("#inscripteurInscription").attr("required", true)
        } else {
            $("#bloc_inscripteurInscription").addClass("visually-hidden")
            $("#inscripteurInscription").removeAttr("required")
        }
    };*/

    // Gestion changement liens parentaux
    const onChangeLiensParentaux = (selectedOption) => {
        if (!selectedOption || !selectedOption.name) {
            console.warn("Aucune option sélectionnée");
            return; 
        }

        const isOtherSelected = selectedOption.name.toLowerCase().includes("autre");

        setInscriptionApprenantForm((prevForm) => ({
            ...prevForm,
            lienparentalId: selectedOption.code,
        }));

        setSelectedLienParental(selectedOption);

        setIsInscripteurVisible(isOtherSelected);
        setIsInscripteurRequired(isOtherSelected);

        if (isOtherSelected) {
            $("#bloc_inscripteurInscription").removeClass("visually-hidden");
            $("#inscripteurInscription").attr("required", true);
        } else {
            $("#bloc_inscripteurInscription").addClass("visually-hidden");
            $("#inscripteurInscription").removeAttr("required");
        }
    };

    const [isInscripteurVisible, setIsInscripteurVisible] = useState(false);
    const [isInscripteurRequired, setIsInscripteurRequired] = useState(false);


    const validateIns = async () => {
        alert("ok");
    }

    // validation et enregistrement des données
    const validateInscription = async (event) => {
        // console.log("ok")
        event.preventDefault()
        /***Check si reste est négatif ou positif */
        //Verifie le reste
        if ((calculMontantRestant - calculFrais) < 0) {
            Swal.fire({
                icon: "error",
                title: "Le montant restant ne peut être négatif",
                showConfirmButton: true,
                timer: 3000,
            });
            return false;

        }
        inscriptionApprenantForm['classeoptionId'] = selectedClasseOption.code
        inscriptionApprenantForm['montantpayePaiement'] = parseInt(montant_recu) //

        inscriptionApprenantForm['reliquatPaiement'] = calculMontantRestant - calculFrais
        //En cas de paiement partiel d'une tranche de la scolarité
        if (selectedTranchePartiel != null) {
            //selectedTrancheScolarite.push(selectedTranchePartiel)
            inscriptionApprenantForm['tranchePartielId'] = selectedTranchePartiel.code//.map(option => { return option.code })
        }
        if (selectedTrancheScolarite != null) {
            inscriptionApprenantForm['tranchescolariteId'] = selectedTrancheScolarite.map(option => { return option.code })
        }
        //Formater les données
        const formattedData = selectedCategories.reduce((acc, option) => {
            acc[option.id] = {
                id: option.id,
                montantPayer: option.montant,
                resteAPayer: 0
            };
            return acc;
        }, {});


        /*inscriptionApprenantForm['categoriegrilletarifaire'] = selectedCategories.map((option, index) => {
            return { id: option.id, montantPayer: option.montant, resteAPayer: option.montant }
        })*/
        inscriptionApprenantForm['categoriegrilletarifaire'] = formattedData
        inscriptionApprenantForm['montantDossierFinancier'] = parseInt(inscriptionApprenantForm.montant_scolarite)
        let montantpayeDossierFinancier = sommeTranche + (parseInt(autreMontantTranche) ? parseInt(autreMontantTranche) : 0) //Somme des #tes tranches + montant partiel
        inscriptionApprenantForm['montantpayeDossierFinancier'] = parseInt(montantpayeDossierFinancier)
        inscriptionApprenantForm['versementPartiel'] = versementPartiel
        inscriptionApprenantForm['autreMontantTranche'] = parseInt(autreMontantTranche)
        inscriptionApprenantForm['fraisInscription'] = parseInt(fraisInscription)
        inscriptionApprenantForm['grilletarifaireId'] = parseInt(fraisInscriptionGrilleTarifaireId)

        console.log(inscriptionApprenantForm)
        //Check si les règles de validations sont respectées avant soumission du formulaire
        //const result = Joi.valide(inscriptionApprenantForm, schema, { abortEarly: false })
        await InscriptionsService.storeInscription(inscriptionApprenantForm, token).then(res => {
            if (res.data.status === 200) {
                Swal.fire({
                    icon: "success",
                    text: res.data.message,
                    timer: 3000,
                });
                //Redirection
                navigate(myroutes.inscriptions)

            } else {
                Swal.fire({
                    icon: "error",
                    text: res.data.message,
                    showConfirmButton: true,
                    timer: 3000,
                });

            }
            console.log(res)
        }).catch(err => {
            console.log(err)
        })
        //console.log(inscriptionApprenantForm)
    }

    //Utilisation du popover de bootstrap
    const nomPersonneRef = useRef(null);
    const prenomsPersonneRef = useRef(null);
    const lienparentalRef = useRef(null);
    //const sexeIdRef = useRef(null);
    const ddnRef = useRef(null);
    const lieuNaissanceRef = useRef(null);
    //const classeIdRef = useRef(null);
    const classeoptionIdRef = useRef(null);
    //const paysIdRef = useRef(null);
    const statutapprenantIdRef = useRef(null);
    const nompereInscriptionRef = useRef(null);
    //const nommereInscriptionRef = useRef(null);
    const contactprincipalInscriptionRef = useRef(null);
    const contactsecondaireInscriptionRef = useRef(null);
    const emailInscriptionRef = useRef(null);
    const montantRecuRef = useRef(null);
    const versementPartielRef = useRef(null);
    const montant_scolariteRef = useRef(null);
    const resteRef = useRef(null);
    const totalRef = useRef(null);
    const autreMontantTrancheRef = useRef(null);
    const trancheScolaritesRef = useRef(null);
    const autreinfoInscriptionRef = useRef(null);
    const inscripteurRef = useRef(null);

    //Transition pour l'affichage des popover
    const transitionOptions = {
        name: 'fade',
        duration: '300ms'
    };

    useEffect(() => {
        fetchSexes()
        fetchPays()
        fecthClasse()
        FetchTypeInscription()
        FetchStatutApprenant()
        fetchTrancheScolarite()
        fetchModePaiements()
        fetchLiensParentaux()
        fetchAnneeacademique()
        //console.log(inscriptionApprenantForm.classeoptionId)
    }, [])


    return (
        <React.Fragment>
            <Form className="needs-validation" noValidate onSubmit={validateInscription}>
                <div className="row">
                    <div className="col-md-12 text-center mb-1">
                        <i className="text-center mx-auto fw-bold">Les champs munis <span className="text-danger">*</span> sont obligatoires. Merci d'en tenir compte.</i>
                    </div>
                    <div className="col-md-12 text-center">
                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">IDENTITE DE L'APPRENANT</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Nom <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => nomPersonneRef.current.toggle(e)}
                                onMouseLeave={(e) => nomPersonneRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={nomPersonneRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                            >
                                Il s'agit du <strong>nom</strong> de l'apprenant à inscrire.
                            </OverlayPanel>
                        </label>
                        <InputText type="text" keyfilter={/^[^<>*!,;$/@)(]+$/} className=" col-12" value={inscriptionApprenantForm.nomPersonne} onChange={(e) => onInputChange(e, 'nomPersonne')} required autoFocus />
                    </div>
                    <div className="col-md-3 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Prénoms <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => prenomsPersonneRef.current.toggle(e)}
                                onMouseLeave={(e) => prenomsPersonneRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={prenomsPersonneRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                                unstyled={true}
                            >
                                Il s'agit du <strong>prénom</strong> de l'apprenant à inscrire.
                            </OverlayPanel>
                        </label>
                        <InputText keyfilter={/^[^<>*!,;$/@)(]+$/} className=" col-12" value={inscriptionApprenantForm.prenomsPersonne} onChange={(e) => onInputChange(e, 'prenomsPersonne')} required />
                    </div>
                    <div className="col-md-3 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Date naissance <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => ddnRef.current.toggle(e)}
                                onMouseLeave={(e) => ddnRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={ddnRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                            >
                                Il s'agit de la <strong>Date de naissance</strong> de l'apprenant à inscrire.
                            </OverlayPanel>
                        </label>
                        <InputText type="date" max={moment(Date()).format("YYYY-MM-DD")} required className=" col-12" value={inscriptionApprenantForm.ddn} onChange={(e) => onInputChange(e, 'ddn')} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Lieu de nais. <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => lieuNaissanceRef.current.toggle(e)}
                                onMouseLeave={(e) => lieuNaissanceRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={lieuNaissanceRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                            >
                                Il s'agit du <strong>Lieu de naissance</strong> de l'apprenant à inscrire.
                            </OverlayPanel>
                        </label>
                        <InputText keyfilter={/^[^<>*!;$@]+$/} className=" col-12" value={inscriptionApprenantForm.lieuNaissance} onChange={(e) => onInputChange(e, 'lieuNaissance')} required />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Sexe <i className="text-danger">*</i>
                        </label>
                        <Dropdown required placeholder="Choisissez une option" name="sexe_id" inputId="sexe_id" value={selectedSexe} onChange={(e) => onChangeSexe(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={sexes} optionLabel="name"
                            filter />
                    </div>

                    <div className="col-md-4 mb-3 visually-hidden ">
                        <label htmlFor="anneeacademiqueId" className="font-bold col-12">
                            Année académique <i className="text-danger">*</i>
                        </label>
                        <input
                            type="text"
                            name="anneeacademiqueId"
                            id="anneeacademiqueId"
                            value={inscriptionApprenantForm.descriptionAnneeacademique || ""}
                            className="w-100"
                            disabled
                        />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Pays/Nationalité <i className="text-danger">*</i></label>
                        <Dropdown required placeholder="Choisissez une option" name="paysId" inputId="paysId" value={selectedPays} onChange={(e) => onChangePays(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={pays} optionLabel="name"
                            filter />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Statut de l'apprenant <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => statutapprenantIdRef.current.toggle(e)}
                                onMouseLeave={(e) => statutapprenantIdRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={statutapprenantIdRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                            >
                                Il s'agit du <strong>Statut</strong> de l'apprenant à inscrire (Passant(e) ou Redoublant(e)).
                            </OverlayPanel>
                        </label>
                        <Dropdown required placeholder="Choisissez une option" name="statutapprenantId" inputId="statutapprenantId" value={selectedStatutApprenant} onChange={(e) => onChangeStatutApprenant(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={statutapprenants} optionLabel="name"
                            filter />
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Classe <i className="text-danger">*</i></label>
                        <Dropdown required placeholder="Choisissez une option" name="classeId" inputId="classeId" value={selectedClasse} onChange={(e) => onChangeClasse(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={classes} optionLabel="name"
                            filter />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Classe option <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => classeoptionIdRef.current.toggle(e)}
                                onMouseLeave={(e) => classeoptionIdRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={classeoptionIdRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                            >
                                Il s'agit de la <strong>Classe</strong> de l'apprenant à inscrire .
                            </OverlayPanel>
                        </label>
                        <Dropdown required placeholder="Choisissez une option" name="classe_option" inputId="classe_option" value={selectedClasseOption} onChange={(e) => onChangeClasseOption(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={classeoptions} optionLabel="name"
                            filter />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="name" className="font-bold col-12">
                            Frais scolarité <i className="text-danger">*</i>
                            <i
                                className="pi pi-question-circle"
                                onMouseEnter={(e) => montant_scolariteRef.current.toggle(e)}
                                onMouseLeave={(e) => montant_scolariteRef.current.hide(e)}
                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                            ></i>
                            <OverlayPanel
                                ref={montant_scolariteRef}
                                showCloseIcon={false}
                                dismissable={true}
                                style={{ width: '200px' }}
                                position="top"
                                transitionOptions={transitionOptions}
                            >
                                Il s'agit des <strong>Frais de scolarité</strong> de la classe option sélectionnée .
                            </OverlayPanel>
                        </label>
                        <InputText disabled className=" col-12" value={inscriptionApprenantForm.montant_scolarite} onChange={(e) => onInputChange(e, 'montant_scolarite')} required style={{ backgroundColor: "#DFDFDF" }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">CONTACT DES PARENTS</h5>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label htmlFor="name" className="font-bold col-12">
                                    Nom et Prénoms du père <i className="text-danger">*</i>
                                    <i
                                        className="pi pi-question-circle"
                                        onMouseEnter={(e) => nompereInscriptionRef.current.toggle(e)}
                                        onMouseLeave={(e) => nompereInscriptionRef.current.hide(e)}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    ></i>
                                    <OverlayPanel
                                        ref={nompereInscriptionRef}
                                        showCloseIcon={false}
                                        dismissable={true}
                                        style={{ width: '200px' }}
                                        position="top"
                                        transitionOptions={transitionOptions}
                                    >
                                        Il s'agit du <strong>Nom et Prénoms du père</strong> de l'apprenant à inscrire.
                                    </OverlayPanel>
                                </label>
                                <InputText keyfilter={/^[^<>*!;$@]+$/} className=" col-12" value={inscriptionApprenantForm.nompereInscription} onChange={(e) => onInputChange(e, 'nompereInscription')} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="name" className="font-bold col-12">
                                    Nom et Prénoms de la mère <i className="text-danger">*</i></label>
                                <InputText keyfilter={/^[^<>*!;$@]+$/} className=" col-12" value={inscriptionApprenantForm.nommereInscription} onChange={(e) => onInputChange(e, 'nommereInscription')} required />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label htmlFor="name" className="font-bold col-12" style={{ fontSize: "90%" }}>
                                    Teléphone principale <i className="text-danger">*</i>
                                    <i
                                        className="pi pi-question-circle"
                                        onMouseEnter={(e) => contactprincipalInscriptionRef.current.toggle(e)}
                                        onMouseLeave={(e) => contactprincipalInscriptionRef.current.hide(e)}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    ></i>
                                    <OverlayPanel
                                        ref={contactprincipalInscriptionRef}
                                        showCloseIcon={false}
                                        dismissable={true}
                                        style={{ width: '200px' }}
                                        position="top"
                                        transitionOptions={transitionOptions}
                                    >
                                        Il s'agit du <strong>numero de Teléphone principale</strong> des parents de l'apprenant à inscrire.
                                    </OverlayPanel>
                                </label>
                                <InputText keyfilter="num" className=" col-12" value={inscriptionApprenantForm.contactprincipalInscription} onChange={(e) => onInputChange(e, 'contactprincipalInscription')} required />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label htmlFor="name" className="font-bold col-12" style={{ fontSize: "90%" }}>
                                    Teléphone secondaire <i className="text-danger"></i>
                                    <i
                                        className="pi pi-question-circle"
                                        onMouseEnter={(e) => contactsecondaireInscriptionRef.current.toggle(e)}
                                        onMouseLeave={(e) => contactsecondaireInscriptionRef.current.hide(e)}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    ></i>
                                    <OverlayPanel
                                        ref={contactsecondaireInscriptionRef}
                                        showCloseIcon={false}
                                        dismissable={true}
                                        style={{ width: '200px' }}
                                        position="top"
                                        transitionOptions={transitionOptions}
                                    >
                                        Il s'agit du <strong>numero de Teléphone secondaire</strong> des parents de l'apprenant à inscrire.
                                    </OverlayPanel>
                                </label>
                                <InputText keyfilter="num" className=" col-12" value={inscriptionApprenantForm.contactsecondaireInscription} onChange={(e) => onInputChange(e, 'contactsecondaireInscription')} />
                            </div>
                            <div className="col-md-12 mb-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="name" className="font-bold col-12" style={{ fontSize: "90%" }}>
                                            E-mail à joindre <i className="text-danger">*</i>
                                            <i
                                                className="pi pi-question-circle"
                                                onMouseEnter={(e) => emailInscriptionRef.current.toggle(e)}
                                                onMouseLeave={(e) => emailInscriptionRef.current.hide(e)}
                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                            ></i>
                                            <OverlayPanel
                                                ref={emailInscriptionRef}
                                                showCloseIcon={false}
                                                dismissable={true}
                                                style={{ width: '200px' }}
                                                position="top"
                                                transitionOptions={transitionOptions}
                                            >
                                                Il s'agit de <strong>l'e-mail</strong> des parents de l'apprenant à inscrire.
                                            </OverlayPanel>
                                        </label>
                                        <InputText keyfilter="email" className=" col-12" value={inscriptionApprenantForm.emailInscription} onChange={(e) => onInputChange(e, 'emailInscription')} required />
                                    </div>
                                    <div className="col-md-6">
                                        {/* Champ Inscripteur (affiché si "Autre" est sélectionné) */}
                                        {isInscripteurVisible && (
                                            <div className="col-md-12 mb-3" id="bloc_inscripteurInscription">
                                                <label htmlFor="inscripteurInscription" className="font-bold col-12" style={{ fontSize: "90%" }}>
                                                    Inscripteur <i className="text-danger">*</i>
                                                    &nbsp;
                                                    <i
                                                        className="pi pi-question-circle"
                                                        onMouseEnter={(e) => inscripteurRef.current.toggle(e)}
                                                        onMouseLeave={(e) => inscripteurRef.current.hide(e)}
                                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                    ></i>
                                                    <OverlayPanel
                                                        ref={inscripteurRef}
                                                        showCloseIcon={false}
                                                        dismissable={true}
                                                        style={{ width: '200px' }}
                                                        position="top"
                                                    >
                                                        Il s'agit du <strong>nom et prénoms</strong> de la personne qui est venue inscrire l'enfant.
                                                    </OverlayPanel>
                                                </label>
                                                <InputText
                                                    keyfilter={/^[^<>*!,;$/@)(]+$/}
                                                    className="col-12"
                                                    value={inscriptionApprenantForm.inscripteurInscription}
                                                    onChange={(e) => onInputChange(e, 'inscripteurInscription')}
                                                    id="inscripteurInscription"
                                                    required={isInscripteurRequired} 
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">AUTRES INFORMATIONS</h5>
                        <div className="row">
                            <div className="col-md-12 mb-3">
                                <label htmlFor="name" className="font-bold col-12">
                                    Lien parental <i className="text-danger">*</i>
                                    <i
                                        className="pi pi-question-circle"
                                        onMouseEnter={(e) => lienparentalRef.current.toggle(e)}
                                        onMouseLeave={(e) => lienparentalRef.current.hide(e)}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    ></i>
                                    <OverlayPanel
                                        ref={lienparentalRef}
                                        showCloseIcon={false}
                                        dismissable={true}
                                        style={{ width: '200px' }}
                                        position="top"
                                        transitionOptions={transitionOptions}
                                    >
                                        Il s'agit du <strong>Lien parental</strong> entre l'apprenant et la personne qui est venu l'inscrire.
                                    </OverlayPanel>
                                </label>
                                <Dropdown required placeholder="Choisissez une option" name="lienparentalId" inputId="lienparentalId" value={selectedLienParental} onChange={(e) => onChangeLiensParentaux(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={liensParentaux} optionLabel="name"
                                    filter />
                            </div>
                            <div className="col-md-12 mb-3">
                                <Form.Label className="form-label" htmlFor="bs-validation-nom">Maladies, antécédents <i className="text-danger"></i>
                                    <i
                                        className="pi pi-question-circle"
                                        onMouseEnter={(e) => autreinfoInscriptionRef.current.toggle(e)}
                                        onMouseLeave={(e) => autreinfoInscriptionRef.current.hide(e)}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    ></i>
                                    <OverlayPanel
                                        ref={autreinfoInscriptionRef}
                                        showCloseIcon={false}
                                        dismissable={true}
                                        style={{ width: '200px' }}
                                        position="top"
                                        transitionOptions={transitionOptions}
                                    >
                                        Il s'agit de la <strong>liste des Maladies dont souffre fréquemment</strong> l'apprenant à inscrire.
                                    </OverlayPanel>
                                </Form.Label>
                                <InputTextarea name="autreinfoInscription" value={inscriptionApprenantForm.autreinfoInscription} onChange={handleAutresInfos} rows={8} cols={22} />
                                <div className="">
                                    {errors.autreinfoInscription && (
                                        <div className="alert alert-danger">
                                            {errors.autreinfoInscription}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3">
                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">FRAIS DIVERS</h5>
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                <label htmlFor="label">Liste des options disponibles</label>
                            </div>
                            <div className="col-md-12 mb-3">
                                <Form.Label className="form-label" htmlFor="bs-validation-nom">Frais Insc <i className="text-danger"></i></Form.Label>
                                <Form.Control className="form-control" name="frais_inscription" type="text" value={fraisInscription.toLocaleString('fr-FR')}
                                    placeholder="" readOnly required={true} />
                            </div>
                            <div className="col-md-12">
                                <div className="flex justify-content-center">
                                    <div className="flex flex-column gap-3">
                                        {listeGrilles.map((grille) => (
                                            <div key={grille.id} className="flex align-items-center mb-2">
                                                <Checkbox
                                                    inputId={grille.id}
                                                    name="category"
                                                    value={grille}
                                                    onChange={onCategoryChange}
                                                    checked={selectedCategories.some((item) => item.id === grille.id) || grille.isRequired}
                                                    disabled={grille.isRequired}
                                                />
                                                { }
                                                &nbsp;<label htmlFor={grille.id} className="ml-2">
                                                    <i>{grille.libelle}</i> {grille.montant.toLocaleString("fr-FR")} FCFA
                                                </label>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/** Tranche scolarite */}
                <div className="row">
                    <div className="col-md-12">
                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2 text-center">PAIEMENTS</h5>
                    </div>

                    <div className="row">
                        <div className="col-md-9" style={{ borderRight: "1px solid grey" }}>
                            <div className="row">
                                {/*Mode de paiement */}
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="name" className="font-bold col-12">
                                        Mode de paiement<i className="text-danger"> *</i>
                                    </label>
                                    <Dropdown required placeholder="Choisissez une option" name="modepaiement" inputId="modepaiement" value={selectedModepaiement} onChange={(e) => onChangeModePaiement(e.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={modepaiements} optionLabel="name"
                                        filter />
                                </div>
                                {/*Montant Reçu  */}
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="name" className="font-bold col-12">
                                        Montant Reçu <i className="text-danger"> *</i>
                                        <i
                                            className="pi pi-question-circle"
                                            onMouseEnter={(e) => montantRecuRef.current.toggle(e)}
                                            onMouseLeave={(e) => montantRecuRef.current.hide(e)}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        ></i>
                                        <OverlayPanel
                                            ref={montantRecuRef}
                                            showCloseIcon={false}
                                            dismissable={true}
                                            style={{ width: '200px' }}
                                            position="top"
                                            transitionOptions={transitionOptions}
                                        >
                                            Il s'agit du <strong>montant perçu</strong> auprès des parents de l'apprenant à inscrire.
                                        </OverlayPanel>
                                    </label>
                                    <Form.Control type="number" id="montant_recu" size="lg" className="col-12 form-control" value={montant_recu} onChange={(e) => onChangeMontantPayer(e)} required max={9999999999} />

                                </div>
                            </div>
                            <div className="row">
                                {/**Tranche */}
                                <div className="col-md-8 mb-3">
                                    <label htmlFor="tranchescolarites">Tranche Scolarités <i className="text-danger"></i></label>
                                    <MultiSelect value={selectedTrancheScolarite} id="selectedTrancheScolarite" onChange={(e) => onChangeTrancheScolarite(e.value)} options={trancheScolarites} optionLabel="name"
                                        filter display="chip" placeholder="Choisissez une option" maxSelectedLabels={4} className="w-100" />
                                </div>

                                <div className="col-md-4 mb-3 py-4">
                                    <Checkbox
                                        inputId="versement_partiel"
                                        name="versement_partiel"
                                        value={versementPartiel}
                                        onChange={onChangeVersementPartiel}
                                        checked={versementPartiel}
                                    />
                                    { }
                                    &nbsp;<label htmlFor="versement_partiel" className="ml-2 fw-bold">
                                        Versement partiel Tranche <i
                                            className="pi pi-question-circle"
                                            onMouseEnter={(e) => versementPartielRef.current.toggle(e)}
                                            onMouseLeave={(e) => versementPartielRef.current.hide(e)}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        ></i>
                                        <OverlayPanel
                                            ref={versementPartielRef}
                                            showCloseIcon={false}
                                            dismissable={true}
                                            style={{ width: '200px' }}
                                            position="top"
                                            transitionOptions={transitionOptions}
                                        >
                                            Vous pouvez cocher cette case si le <strong>parent veut payer une partie de la tranche de scolarité</strong> de l'apprenant à inscrire.
                                        </OverlayPanel>
                                    </label>
                                </div>
                            </div>
                            <hr />
                            <div className="row visually-hidden" id="bloc_tranche_partiel">
                                <div className="col-md-6">
                                    <label htmlFor="trancheSelected" className="fw-bold">Tranche Scolarité Concernée <i className="text-danger">*</i>
                                        <i
                                            className="pi pi-question-circle"
                                            onMouseEnter={(e) => trancheScolaritesRef.current.toggle(e)}
                                            onMouseLeave={(e) => trancheScolaritesRef.current.hide(e)}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        ></i>
                                        <OverlayPanel
                                            ref={trancheScolaritesRef}
                                            showCloseIcon={false}
                                            dismissable={true}
                                            style={{ width: '200px' }}
                                            position="top"
                                            transitionOptions={transitionOptions}
                                        >
                                            Il s'agit de la <strong>Tranche de scolarité dont le parent veut effectuer un paiement partiel</strong>. La tranche sélectionnée à ce niveau doit être différent de celui du haut.
                                        </OverlayPanel>
                                    </label>
                                    <Dropdown placeholder="Choisissez une option" name="trancheSelected" inputId="trancheSelected" value={selectedTranchePartiel} onChange={(e) => setSelectedTranchePartiel(e.target.value)} className={`w-100 ${classNames({ 'p-invalid': '' })}`} options={listeTrancheScolaritePartiel} optionLabel="name"
                                        filter />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="autreMontantTranche" className="fw-bold">Montant partiel à payer <i className="text-danger">*</i>
                                        <i
                                            className="pi pi-question-circle"
                                            onMouseEnter={(e) => autreMontantTrancheRef.current.toggle(e)}
                                            onMouseLeave={(e) => autreMontantTrancheRef.current.hide(e)}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        ></i>
                                        <OverlayPanel
                                            ref={autreMontantTrancheRef}
                                            showCloseIcon={false}
                                            dismissable={true}
                                            style={{ width: '200px' }}
                                            position="top"
                                            transitionOptions={transitionOptions}
                                        >
                                            Il s'agit du <strong> montant partiel que le parent veux payer</strong>.
                                        </OverlayPanel>
                                    </label>
                                    <Form.Control type="number" id="autreMontantTranche" size="lg" className="col-12 form-control" value={autreMontantTranche} onChange={(e) => onChangeMontantPartielPayer(e)} max={9999999999} />

                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="row">
                                <div className="col-md-12 mb-3" id="">
                                    <label htmlFor="total" className="fw-bold">Total <i className="text-danger">*</i>&nbsp;
                                        <i
                                            className="pi pi-question-circle"
                                            onMouseEnter={(e) => totalRef.current.toggle(e)}
                                            onMouseLeave={(e) => totalRef.current.hide(e)}
                                            style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        ></i>
                                        <OverlayPanel
                                            ref={totalRef}
                                            showCloseIcon={false}
                                            dismissable={true}
                                            style={{ width: '200px' }}
                                            position="top"
                                            transitionOptions={transitionOptions}
                                        >
                                            Il s'agit du <strong>total des frais à payer</strong> y compris les frais d'inscription, les montants des tranches de scolarités sélectionnée sur le formulaire et les frais divers.
                                        </OverlayPanel>
                                    </label>
                                    <InputNumber id="sommeFrais" disabled className="col-12" value={calculFrais} required locale="de-DE" style={{ backgroundColor: "#DFDFDF", borderRadius: "7px" }} />
                                </div>
                            </div>
                            {/***
                             * <div className="row ">
                                {/***Ce champ s'affiche si aucune tranche ne couvre totalement le montant reçu  ///
                                <div className="col-md-12 visually-hidden mb-3" id="bloc_tranche_scolarite">
                                    <label htmlFor="autres">Autres <i className="text-danger">*</i></label>

                                    <InputNumber id="autre_montant_tranche" className="col-12" value={inscriptionApprenantForm.autre_montant_tranche} onChange={(e) => onInputChange(e, 'autre_montant_tranche')} required locale="de-DE" />
                                </div>
                            </div>
                             */}

                            <div className="col-md-12 mb-3">
                                <label htmlFor="reste" className="font-bold col-12 fw-bold">
                                    Reste <i className="text-danger"> </i>
                                    <i
                                        className="pi pi-question-circle"
                                        onMouseEnter={(e) => resteRef.current.toggle(e)}
                                        onMouseLeave={(e) => resteRef.current.hide(e)}
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                    ></i>
                                    <OverlayPanel
                                        ref={resteRef}
                                        showCloseIcon={false}
                                        dismissable={true}
                                        style={{ width: '200px' }}
                                        position="top"
                                        transitionOptions={transitionOptions}
                                    >
                                        Il s'agit du <strong> reste à payer</strong> après soustraction de tous les frais d'inscription, les montants des tranches de scolarités sélectionnée sur le formulaire et les frais divers.
                                    </OverlayPanel>
                                </label>
                                <Form.Control id="reste" disabled className="col-12" value={calculMontantRestant - calculFrais} required />

                            </div>

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12" style={{ textAlign: "right" }}>
                        <Button label="Valider le formulaire" type="submit" severity="warning" rounded />
                    </div>
                </div>
            </Form>
        </React.Fragment >
    )

};